/**
 * This file contains all translations needed across the project's JavaScript files.
 *
 * Example usage:
 * import {translation, lang} from './translations'; // adjust path accordingly
 * const myTranslation = translation[lang].clientFilterToggleButtonShow;
 */

const lang = document.documentElement.lang;
const de = 'de-de';
const en = 'en-US';

let translation = {};
translation[de] = {};
translation[en] = {};

translation[de].clientFilterToggleButtonShow = 'Filter einblenden';
translation[de].clientFilterToggleButtonHide = 'Filter ausblenden';

translation[en].clientFilterToggleButtonShow = 'Show filters';
translation[en].clientFilterToggleButtonHide = 'Hide filters';

module.exports = {
    translation,
    lang
};
